import { ToastStateHandler, UserApi } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { EditMedicalLeaveRequestDto } from '../../../commonTypes/organization.types';
import { ACCESS_TOKEN, ID_TOKEN, LocalStorage } from '../../../util/LocalStorage';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const MAX_FILE_SIZE_BYTES = 20000000;

const useHttpEditMedicalLeaveRequest = () => {
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const storage = useContainer(LocalStorage);
    const { t } = useTranslation();

    const editMedicalLeaveRequest = async (
        { id, startDate, endDate, description, files }: Partial<EditMedicalLeaveRequestDto> & { id: string },
        callback: ICallback
    ) => {
        try {
            const safeFiles: File[] = files ?? [];

            if (safeFiles.some((file: File) => file.size > MAX_FILE_SIZE_BYTES)) {
                return;
            }

            const res = await userApi.editMedicalLeaveRequest({
                id,
                startDate,
                endDate,
                description,
                files: safeFiles,
                accessToken: storage.get(ACCESS_TOKEN),
                idToken: storage.get(ID_TOKEN),
            });

            toastHandler.push(
                'success',
                t('medicalLeaveRequest.notifications.editMedicalLeaveRequestTitle'),
                t('medicalLeaveRequest.notifications.editMedicalLeaveRequestSucceededMessage')
            );
            callback.onSuccess?.(res);
            return res;
        } catch (err: any) {
            console.error(err);
            toastHandler.push(
                'error',
                t('medicalLeaveRequest.notifications.editMedicalLeaveRequestTitle'),
                t('medicalLeaveRequest.notifications.editMedicalLeaveRequestFailedMessage')
            );
            callback.onError?.(err);
        }
    };

    return { editMedicalLeaveRequest };
};

export default useHttpEditMedicalLeaveRequest;
